'use client'

import { useState, useEffect } from 'react'
import { FaCookieBite, FaExclamationTriangle, FaTimes } from 'react-icons/fa'
import Link from 'next/link'

export default function CookieConsent() {
  const [showPopup, setShowPopup] = useState(false)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookie-consent')
    if (!consent) {
      // Show popup after a short delay for better UX
      setTimeout(() => {
        setShowPopup(true)
        setTimeout(() => setIsVisible(true), 100)
      }, 1000)
    }
  }, [])

  const acceptCookies = () => {
    localStorage.setItem('cookie-consent', 'accepted')
    setIsVisible(false)
    setTimeout(() => setShowPopup(false), 300)
  }

  const declineCookies = () => {
    localStorage.setItem('cookie-consent', 'declined')
    setIsVisible(false)
    setTimeout(() => setShowPopup(false), 300)
  }

  const closePopup = () => {
    // Allow closing without making a choice (will show again next visit)
    setIsVisible(false)
    setTimeout(() => setShowPopup(false), 300)
  }

  if (!showPopup) return null

  return (
    <div className={`fixed inset-0 z-50 flex items-end justify-center p-4 ${isVisible ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}>
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={closePopup}></div>

      {/* Cookie Popup */}
      <div className={`relative bg-white rounded-lg shadow-xl max-w-md w-full transform transition-transform duration-300 ${isVisible ? 'translate-y-0' : 'translate-y-full'}`}>
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <FaCookieBite className="text-primary text-xl" />
            <h3 className="text-lg font-semibold text-primary-dark">Cookie-Einstellungen</h3>
          </div>
          <button
            onClick={closePopup}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Schließen"
          >
            <FaTimes />
          </button>
        </div>

        {/* Content */}
        <div className="p-4">
          <p className="text-primary-dark text-sm leading-relaxed mb-4">
            Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern.
            Cookies helfen uns dabei, Ihnen relevante Inhalte zu zeigen und die Website-Funktionen zu optimieren.
          </p>

          <div className="text-xs text-primary mb-4">
            <p className="font-medium mb-1">Welche Cookies verwenden wir?</p>
            <ul className="list-disc list-inside space-y-1">
              <li>Notwendige Cookies für die Grundfunktionalität</li>
              <li>Analyse-Cookies zur Verbesserung der Website</li>
              <li>Funktionale Cookies für erweiterte Features</li>
            </ul>
          </div>
                <div className="flex items-center gap-2 bg-yellow-100 text-yellow-900 p-3 rounded-lg mb-4 border border-yellow-200">
              <FaExclamationTriangle className="w-5 h-5" />
              <span className="text-sm font-semibold">KEINE ERSATZTEILE</span>
            </div>

          <p className="text-xs text-primary-dark">
            Weitere Informationen finden Sie in unserer{' '}
            <Link href="/datenschutzerklarung" className="text-primary-dark underline hover:text-primary-dark/80">
              Datenschutzerklärung
            </Link>
            .
          </p>
        </div>

        {/* Buttons */}
        <div className="flex gap-3 p-4 border-t border-primary-light">
          <button
            onClick={declineCookies}
            className="flex-1 px-4 py-2 text-primary-dark border border-primary-light rounded-lg hover:bg-primary-light/20 transition-colors text-sm font-medium"
          >
            Ablehnen
          </button>
          <button
            onClick={acceptCookies}
            className="flex-1 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors text-sm font-medium"
          >
            Akzeptieren
          </button>
        </div>
      </div>
    </div>
  )
}